import { ReactNode } from 'react'

import { CardWrapper } from './Wrapper'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'
import { IconWrapper } from 'shared/atoms'

type SummaryProps = WithClassName<{
	title: string
	content: string | ReactNode
	summaryCounter?: string | ReactNode
	summaryCounterColor?: string
	summaryText?: string
	icon?: ReactNode
	iconBgColor?: string
	iconColor?: string
	compact?: boolean
}>

export const Summary = ({
	title,
	content,
	summaryCounter,
	summaryCounterColor = 'text-success',
	summaryText,
	className,
	icon,
	iconBgColor = 'bg-primary-soft',
	iconColor = 'text-primary',
	compact = false
}: SummaryProps) => {
	if (compact) {
		return (
			<CardWrapper className={cn('relative px-4 py-3', className)}>
				<h3 className="truncate pr-10 text-[11px] font-medium text-muted-foreground">{title}</h3>
				<span className="mt-0.5 block whitespace-nowrap pr-10 font-display text-[16px] font-bold tabular-nums leading-tight text-foreground">
					{content}
				</span>
				{icon ? (
					<IconWrapper
						className="absolute right-4 top-3"
						iconBgColor={iconBgColor}
						iconColor={iconColor}
						size="sm">
						{icon}
					</IconWrapper>
				) : null}
			</CardWrapper>
		)
	}

	return (
		<CardWrapper className={cn('relative flex flex-col p-4', className)}>
			<h3 className="truncate pr-12 text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
				{title}
			</h3>
			<span className="mt-2 block whitespace-nowrap pr-12 font-display text-[24px] font-bold tabular-nums leading-none text-foreground 2xl:text-[26px]">
				{content}
			</span>
			{summaryCounter || summaryText ? (
				<p className="mt-3 text-[11px] font-medium text-muted-foreground">
					{summaryCounter ? <span className={summaryCounterColor}>{summaryCounter}</span> : null}{' '}
					<span>{summaryText}</span>
				</p>
			) : null}
			{icon ? (
				<IconWrapper
					className="absolute right-4 top-4"
					iconBgColor={iconBgColor}
					iconColor={iconColor}>
					{icon}
				</IconWrapper>
			) : null}
		</CardWrapper>
	)
}
